import { createContext, useContext, type ReactNode } from 'react';
import type { JSX } from 'react';

import { AppStore, getAppStore } from './AppStore';

const AppStoreContext = createContext<AppStore | null>(null);

/**
 * 注入应用运行时。
 *
 * 生产代码**不需要**它：`useAppStore()` 在没被包裹时会落到模块级单例，也就是
 * "全应用一份"。它存在的意义只有一个：测试里每个用例都需要一条自己的链路
 * （自己的模拟机、自己的时钟、自己的订阅计数），而共享单例的测试会互相干扰 ——
 * 那种干扰的表现是"单独跑过、一起跑挂"，最难查。
 */
export function AppStoreProvider({
  store,
  children,
}: {
  readonly store: AppStore;
  readonly children: ReactNode;
}): JSX.Element {
  return <AppStoreContext.Provider value={store}>{children}</AppStoreContext.Provider>;
}

export function useAppStore(): AppStore {
  return useContext(AppStoreContext) ?? getAppStore();
}
